import { useEffect, useRef, useState } from 'react';
import dayjs from 'dayjs';
import DayPicker, { DateUtils, type RangeModifier, type Modifier } from 'react-day-picker';
import type { IDate } from './datePicker';
import { DatePickerCaption } from './datePickerCaption';
import { Input } from '@shared/widgets';

interface RangePickerProps {
  range: IDate;
  past?: boolean;
  future?: boolean;
  onDayClick: (date: IDate) => void;
}

export const RangePicker = (props: RangePickerProps) => {
  const [selectedDate, setSelectedDate] = useState<IDate>(props.range);
  const dayPickerRef = useRef<DayPicker | null>(null);

  useEffect(() => {
    if (selectedDate.from) dayPickerRef.current?.showMonth(selectedDate.from);
  }, []);

  const handleDayClick = (day: Date) => {
    const range = DateUtils.addDayToRange(day, selectedDate as RangeModifier);
    setSelectedDate(range);
    props.onDayClick(range);
  };

  const handleYearMonthChange = (month: Date) => dayPickerRef.current?.showMonth(month);

  const { from, to } = selectedDate;
  const tomorrow = new Date();
  tomorrow.setDate(new Date().getDate() + 1);
  tomorrow.setHours(0, 0, 0, 0);

  const selectedDays = [from, from && to && { from, to }].filter(Boolean) as Modifier[];
  return (
    <div>
      <div className='flex gap-4 px-4 pt-1 pb-1.5'>
        <div className='flex flex-col gap-1.5'>
          <label htmlFor='date-from' className='text-[11px] font-semibold text-[#666] uppercase'>
            Date from
          </label>
          <Input
            id='date-from'
            className='!p-2.5 !text-xs placeholder:!text-xs'
            variant='outlined'
            value={from ? dayjs.utc(from).format('ddd, DD MMM') : ''}
            placeholder='SELECT DATE'
            readOnly
          />
        </div>
        <div className='flex flex-col gap-1.5'>
          <label htmlFor='date-to' className='text-[11px] font-semibold text-[#666] uppercase'>
            Date to
          </label>
          <Input
            id='date-to'
            className='!p-2.5 !text-xs placeholder:!text-xs'
            variant='outlined'
            value={to ? dayjs.utc(to).format('ddd, DD MMM') : ''}
            placeholder='SELECT DATE'
            readOnly
          />
        </div>
      </div>
      <DayPicker
        ref={dayPickerRef}
        className='w-full !pt-0 text-[#fff]'
        numberOfMonths={1}
        selectedDays={selectedDays}
        onDayClick={handleDayClick}
        firstDayOfWeek={1}
        captionElement={<DatePickerCaption date={from ? new Date(from) : new Date()} onChange={handleYearMonthChange} />}
      />
    </div>
  );
};
